"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemOfferSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.ItemOfferSchema = __1.BaseSchema.extend({
    attributes: zod_1.z.array(_1.ItemAttributeSchema).optional(),
    category: _1.ItemCategorySchema.optional(),
    channel: __1.ChannelPartialWithIdSchema,
    competitivePrice: _1.CompetitivePriceSchema.optional(),
    description: zod_1.z.string().optional(),
    /**
     * The {@link IItemVariant} id for the item variant
     */
    variantId: __1.ShortStringSchema.optional(),
    /**
     * An item offer might be eligible for catalog listing in some channels, this property indicates the status of the offer in the catalog.
     */
    catalogStatus: zod_1.z.nativeEnum(__1.OfferCatalogStatus).optional(),
    price: __1.MoneySchema.optional(),
    quality: _1.ItemOfferQualitySchema.optional(),
    quantityAvailable: zod_1.z.number().optional(),
    quantityReserved: zod_1.z.number().optional(),
    quantitySold: zod_1.z.number().optional(),
    quantityTotal: zod_1.z.number().optional(),
    status: zod_1.z.nativeEnum(__1.OfferStatus),
    statusReason: __1.LongStringSchema.optional(),
    title: __1.ShortStringSchema.optional(),
    /**
     * The {@link channel} generated id for the item listing, this property is used to sync back changes that might happen on the channel and must be reflected on RediRedi data.
     */
    channelId: __1.ShortStringSchema.optional(),
    /**
     * The {@link channel} generated variant id for the item variants listing, this property is used to difference item variants synced of channels.
     */
    channelVariantId: __1.ShortStringSchema.optional(),
    /**
     * URL where a buyer can buy the item on the respective channel.
     */
    channelBuyUrl: __1.LongStringSchema.url().optional(),
    /**
     * URL where the store manager can edit item details on the respective channel.
     */
    channelEditUrl: __1.LongStringSchema.url().optional(),
    /**
     * Every additional information about the item that are specific to the {@link channel}.
     */
    channelAdditionalData: zod_1.z.record(zod_1.z.unknown()).optional(),
    /**
     * Some channels provides a catalog listing option, this property is used to related the item offer to the catalog item listing.
     */
    channelCatalogItemId: __1.ShortStringSchema.optional(),
    /**
     * Issues related to the item offer.
     */
    issues: zod_1.z.array(_1.OfferIssueSchema).optional(),
    source: zod_1.z.nativeEnum(__1.ItemSource).optional(),
    /**
     *  The minimum quantity of the item that must be available in stock to be listed on the channel.
     */
    minimumQuantityAvailable: zod_1.z.number().nonnegative().optional(),
    promotionPrice: __1.MoneySchema.optional(),
});
//# sourceMappingURL=item-offer.js.map